import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setStock } from '../actions'
import Funding from './Funding'

const mapStateToProps = state => ({
  wizards: state.wizards,
  stock: state.stock
})

const mapDispatchToProps = {
  setWizards,
  setStock
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Funding)
